module.exports = __webpack_public_path__ + "static/img/post.8a487fcf.jpg";